import { render, staticRenderFns } from "./hongbao.vue?vue&type=template&id=3474880c&scoped=true&"
import script from "./hongbao.vue?vue&type=script&lang=js&"
export * from "./hongbao.vue?vue&type=script&lang=js&"
import style0 from "./hongbao.vue?vue&type=style&index=0&id=3474880c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3474880c",
  null
  
)

export default component.exports